import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function FounderInsightSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-slate-900 py-24 lg:py-32 relative" data-id="element-178">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-179">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="bg-slate-800/30 border border-slate-700/50 rounded-3xl p-10 md:p-16 relative overflow-hidden" data-id="element-180">
          {/* Subtle glow */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-tiq-purple/10 rounded-full blur-[100px] -z-10" data-id="element-181" />

          <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-182">
            Why TalentIQ Exists
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-slate-300 leading-relaxed max-w-2xl mx-auto" data-id="element-183">
            <p data-id="element-184">For years the conversation focused on the future of work.</p>
            <p data-id="element-185">
              But in mission-critical environments, the real challenge isn't
              work.
            </p>
            <p className="text-2xl font-bold text-white" data-id="element-186">It's readiness.</p>
            <p data-id="element-187">
              TalentIQ was built to help leaders understand whether teams are
              truly prepared before operational decisions are made.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}